import React, {useState} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import {designUsingToastState, toastDeltaUpdatesState, toastRestaurantsState} from "../../state/atoms";
import {ToastDeltaUpdate} from "../../generated/dashboard-client";
import {approveAll, approveAllForDesignIds, ignore, onReviewApprove, Pos, review} from "../../service/PosService";
import GenericDesignUpdater from "./GenericDesignUpdater";

interface ToastDesignUpdaterProps {
  loading: boolean
}

const pos = Pos.Toast;

export default function ToastDesignUpdater({loading}: ToastDesignUpdaterProps) {
  const toastRestaurants = useRecoilValue(toastRestaurantsState);
  const [reviewDesignId, setReviewDesignId] = useState('');
  const [isReviewModal, setReviewModal] = useState(false);
  const [toastReviewUpdates, setToastReviewUpdates] = useState([] as ToastDeltaUpdate[]);
  const [loadingDesignIds, setLoadingDesignIds] = useState([] as string[]);
  const [designsUsingToast, setDesignsUsingToast] = useRecoilState(designUsingToastState);
  const [toastDeltaUpdates, setToastDeltaUpdates] = useRecoilState(toastDeltaUpdatesState);
  const [optionsModalDesignId, setOptionsModalDesignId] = useState('');

  async function onToastReviewApprove(ids: string[]) {
    await onReviewApprove(ids, setReviewModal, setLoadingDesignIds, reviewDesignId, toastRestaurants, toastDeltaUpdates, designsUsingToast, setDesignsUsingToast, pos, setToastDeltaUpdates, setOptionsModalDesignId);
  }

  async function toastApproveAll(e: React.MouseEvent<HTMLElement>, designId: string) {
    await approveAll(e, designId, setLoadingDesignIds, setOptionsModalDesignId, designsUsingToast, setDesignsUsingToast, pos, toastRestaurants, toastDeltaUpdates, setToastDeltaUpdates);
  }

  async function toastApproveAllForDesignIds(e: React.MouseEvent<HTMLElement>, designIds: string[]) {
    await approveAllForDesignIds(e, designIds, setLoadingDesignIds, setOptionsModalDesignId, designsUsingToast, setDesignsUsingToast, pos, toastRestaurants, toastDeltaUpdates, setToastDeltaUpdates);
  }

  function toastReview(e: React.MouseEvent<HTMLElement>, designId: string) {
    review(e, designId, setReviewModal, setReviewDesignId, toastDeltaUpdates, setToastReviewUpdates);
  }

  async function toastIgnore(e: React.MouseEvent<HTMLElement>, designId: string) {
    await ignore(e, designId, setLoadingDesignIds, toastRestaurants, pos, toastDeltaUpdates, setToastDeltaUpdates, setOptionsModalDesignId, designsUsingToast);
  }

  return <GenericDesignUpdater posReview={toastReview} posApproveAll={toastApproveAll} posApproveAllForDesignIds={toastApproveAllForDesignIds} posIgnore={toastIgnore}
                               deltaUpdates={toastDeltaUpdates} designs={designsUsingToast} optionsModalDesignId={optionsModalDesignId}
                               reviewUpdates={toastReviewUpdates} loading={loading} loadingDesignIds={loadingDesignIds}
                               onReviewApprove={onToastReviewApprove}
                               setOptionsModalDesignId={setOptionsModalDesignId} isReviewModal={isReviewModal} setReviewModal={setReviewModal}
                               restaurants={toastRestaurants} pos={pos}/>
}
